// GERADO por scripts/gerar-regras-icms-st.py -- NAO editar a mao.
//
// PRINCIPIO (Kaio): o orcamento segue a parametrizacao ATIVA do Nomus, mesmo quando esta errada, ate o financeiro corrigi-la --
// "nao posso passar um valor para o cliente e depois cobrar outro". Divergencias com a lei ou com a contabilidade viram `alerta`.
// Fonte: Planilha_Tributacao_Consolidada_Revisada.xlsx, aba "Regras ativas", conferida contra as NF-e emitidas desde 2025-01-01.
// Spec: docs/superpowers/specs/2026-10-06-icms-st-na-proposta.md
//
//   nivel         validado: a ultima sequencia de notas emitidas (desde `validadoDesde`) reproduz a conta ao centavo;
//                 parametrizado: regra unica no Nomus, sem nota para confirmar; a_confirmar: NAO calcula (ver `motivo`)
//   movimentacoes IDs dos tipos de venda do Nomus em que a regra vale (VENDA LOJISTA, SHOWROOM...). Em outro tipo de venda
//                 (CORPORATIVA, CONSUMIDOR FINAL...) o Nomus NAO cobra ST: medido, 0 de 130 itens corporativos e 0 de 98 de consumidor final
//   deducao       RJ (operacao interna) ou onde o Nomus deduz algo diferente da lei: a deducao do Nomus; no resto vale a da lei
//   clientes      nomes (normalizados) dos clientes a quem a regra se aplica; a regra geral vale para os demais
//   alerta        o que o financeiro/contabilidade precisam saber sobre a regra (mostrado na etiqueta do item)
//
// Para atualizar: regerar a partir da planilha nova e revisar o diff -- quem aprova a regra e a contabilidade.

export const VERSAO_REGRAS = "2026-10-07";

export const REGRAS_ICMS_ST = [
 {
  "uf": "AC",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 36.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "82"
  ]
 },
 {
  "uf": "AC",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 36.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "153"
  ]
 },
 {
  "uf": "AC",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "60"
  ]
 },
 {
  "uf": "AC",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 46.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "106"
  ]
 },
 {
  "uf": "AC",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 46.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "163"
  ]
 },
 {
  "uf": "AC",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "73"
  ]
 },
 {
  "uf": "AC",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "197"
  ]
 },
 {
  "uf": "AC",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "175",
   "211"
  ]
 },
 {
  "uf": "AC",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "176"
  ]
 },
 {
  "uf": "AC",
  "ncm": "76169900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "93"
  ]
 },
 {
  "uf": "AC",
  "ncm": "76169900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "deducao": 7.0,
  "alerta": "O Nomus deduz 7% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 4%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "93"
  ]
 },
 {
  "uf": "AC",
  "ncm": "85044029",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "22"
  ]
 },
 {
  "uf": "AC",
  "ncm": "85044029",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "135"
  ]
 },
 {
  "uf": "AC",
  "ncm": "94051190",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 39.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "26"
  ]
 },
 {
  "uf": "AC",
  "ncm": "94051190",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 39.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "128"
  ]
 },
 {
  "uf": "AC",
  "ncm": "94054900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 39.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "112"
  ]
 },
 {
  "uf": "AC",
  "ncm": "94054900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 39.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "133"
  ]
 },
 {
  "uf": "AL",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "73"
  ]
 },
 {
  "uf": "AL",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "197"
  ]
 },
 {
  "uf": "AM",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "198"
  ]
 },
 {
  "uf": "AM",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "199"
  ]
 },
 {
  "uf": "AP",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 36.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "83"
  ]
 },
 {
  "uf": "AP",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 36.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "154"
  ]
 },
 {
  "uf": "AP",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "61"
  ]
 },
 {
  "uf": "AP",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "142"
  ]
 },
 {
  "uf": "AP",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "74"
  ]
 },
 {
  "uf": "AP",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "200"
  ]
 },
 {
  "uf": "AP",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "179"
  ]
 },
 {
  "uf": "AP",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "178"
  ]
 },
 {
  "uf": "AP",
  "ncm": "76169900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "94"
  ]
 },
 {
  "uf": "AP",
  "ncm": "76169900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "deducao": 7.0,
  "alerta": "O Nomus deduz 7% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 4%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "94"
  ]
 },
 {
  "uf": "AP",
  "ncm": "85044029",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "23"
  ]
 },
 {
  "uf": "AP",
  "ncm": "85044029",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "136"
  ]
 },
 {
  "uf": "BA",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "validadoDesde": "2025-01-30",
  "notas": 2,
  "regrasNomus": [
   "84"
  ]
 },
 {
  "uf": "BA",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "155"
  ]
 },
 {
  "uf": "BA",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "62"
  ]
 },
 {
  "uf": "BA",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "143"
  ]
 },
 {
  "uf": "BA",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 55.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "validadoDesde": "2025-01-28",
  "notas": 3,
  "regrasNomus": [
   "115"
  ]
 },
 {
  "uf": "BA",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 55.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "165"
  ]
 },
 {
  "uf": "BA",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "201"
  ]
 },
 {
  "uf": "BA",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "202"
  ]
 },
 {
  "uf": "BA",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "180"
  ]
 },
 {
  "uf": "BA",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "181"
  ]
 },
 {
  "uf": "DF",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 36.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "122"
  ]
 },
 {
  "uf": "DF",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 36.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "156"
  ]
 },
 {
  "uf": "DF",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "120"
  ]
 },
 {
  "uf": "DF",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "144"
  ]
 },
 {
  "uf": "DF",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "198"
  ]
 },
 {
  "uf": "DF",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "199"
  ]
 },
 {
  "uf": "DF",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "183"
  ]
 },
 {
  "uf": "DF",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "182"
  ]
 },
 {
  "uf": "DF",
  "ncm": "76169900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "94"
  ]
 },
 {
  "uf": "DF",
  "ncm": "76169900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "deducao": 7.0,
  "alerta": "O Nomus deduz 7% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 4%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "94"
  ]
 },
 {
  "uf": "DF",
  "ncm": "85044029",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "124"
  ]
 },
 {
  "uf": "DF",
  "ncm": "85044029",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "137"
  ]
 },
 {
  "uf": "DF",
  "ncm": "94051190",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 39.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "validadoDesde": "2026-06-30",
  "notas": 1,
  "regrasNomus": [
   "27"
  ]
 },
 {
  "uf": "DF",
  "ncm": "94051190",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 39.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "validadoDesde": "2025-02-27",
  "notas": 3,
  "regrasNomus": [
   "129"
  ]
 },
 {
  "uf": "DF",
  "ncm": "94054900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "parametrizado",
  "mva": 39.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "116"
  ]
 },
 {
  "uf": "DF",
  "ncm": "94054900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 39.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "134"
  ]
 },
 {
  "uf": "ES",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 36.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "173"
  ]
 },
 {
  "uf": "ES",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 36.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "validadoDesde": "2025-04-28",
  "notas": 2,
  "regrasNomus": [
   "85"
  ]
 },
 {
  "uf": "ES",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "63"
  ]
 },
 {
  "uf": "ES",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "145"
  ]
 },
 {
  "uf": "ES",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 46.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "167"
  ]
 },
 {
  "uf": "ES",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "184"
  ]
 },
 {
  "uf": "ES",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "185"
  ]
 },
 {
  "uf": "MA",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 22.0,
  "fcp": 0.0,
  "deducao": 12.0,
  "alerta": "MA: a fonte oficial é incompleta (spec de 30/09). O Nomus cobra mesmo assim. O Nomus deduz 12% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 7%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "203"
  ]
 },
 {
  "uf": "MA",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 22.0,
  "fcp": 0.0,
  "alerta": "MA: a fonte oficial é incompleta (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "204"
  ]
 },
 {
  "uf": "MG",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-03-31",
  "notas": 8,
  "regrasNomus": [
   "86"
  ]
 },
 {
  "uf": "MG",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-04-25",
  "notas": 4,
  "regrasNomus": [
   "157"
  ]
 },
 {
  "uf": "MG",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "64"
  ]
 },
 {
  "uf": "MG",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-06-06",
  "notas": 1,
  "regrasNomus": [
   "107"
  ]
 },
 {
  "uf": "MG",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 50.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-03-31",
  "notas": 7,
  "regrasNomus": [
   "21"
  ]
 },
 {
  "uf": "MG",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 50.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "138"
  ]
 },
 {
  "uf": "MG",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "75"
  ]
 },
 {
  "uf": "MG",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 71.78,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-07-28",
  "notas": 3,
  "regrasNomus": [
   "205"
  ]
 },
 {
  "uf": "MG",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "186"
  ]
 },
 {
  "uf": "MG",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "187"
  ]
 },
 {
  "uf": "MG",
  "ncm": "76169900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "97"
  ]
 },
 {
  "uf": "MG",
  "ncm": "76169900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "deducao": 12.0,
  "alerta": "O Nomus deduz 12% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 4%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "97"
  ]
 },
 {
  "uf": "MG",
  "ncm": "85044029",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 50.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-01-31",
  "notas": 5,
  "regrasNomus": [
   "21"
  ]
 },
 {
  "uf": "MG",
  "ncm": "85044029",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 50.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-01-09",
  "notas": 407,
  "regrasNomus": [
   "138"
  ]
 },
 {
  "uf": "MG",
  "ncm": "94051190",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-01-09",
  "notas": 1442,
  "regrasNomus": [
   "16"
  ]
 },
 {
  "uf": "MG",
  "ncm": "94051190",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "validado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-02-10",
  "notas": 82,
  "regrasNomus": [
   "130"
  ]
 },
 {
  "uf": "MG",
  "ncm": "94054900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-04-24",
  "notas": 1,
  "regrasNomus": [
   "16"
  ]
 },
 {
  "uf": "MG",
  "ncm": "94054900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "validado",
  "mva": 45.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "validadoDesde": "2025-01-30",
  "notas": 34,
  "regrasNomus": [
   "130"
  ]
 },
 {
  "uf": "MS",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 38.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "118"
  ]
 },
 {
  "uf": "MS",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 38.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "158"
  ]
 },
 {
  "uf": "MS",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 38.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "65"
  ]
 },
 {
  "uf": "MS",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 38.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "146"
  ]
 },
 {
  "uf": "MS",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 38.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "46"
  ]
 },
 {
  "uf": "MS",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 38.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "168"
  ]
 },
 {
  "uf": "MS",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 38.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "188"
  ]
 },
 {
  "uf": "MS",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 38.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "189"
  ]
 },
 {
  "uf": "MT",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "87"
  ]
 },
 {
  "uf": "MT",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "159"
  ]
 },
 {
  "uf": "MT",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "66"
  ]
 },
 {
  "uf": "MT",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "147"
  ]
 },
 {
  "uf": "MT",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   55
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "36"
  ]
 },
 {
  "uf": "MT",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   55
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "169"
  ]
 },
 {
  "uf": "MT",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 65.29,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "76"
  ]
 },
 {
  "uf": "MT",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 65.29,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "206"
  ]
 },
 {
  "uf": "MT",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "191"
  ]
 },
 {
  "uf": "MT",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "190"
  ]
 },
 {
  "uf": "MT",
  "ncm": "76169900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "98"
  ]
 },
 {
  "uf": "MT",
  "ncm": "76169900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 52.14,
  "aliquota": 17.0,
  "fcp": 0.0,
  "deducao": 7.0,
  "alerta": "O Nomus deduz 7% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 4%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "98"
  ]
 },
 {
  "uf": "MT",
  "ncm": "85044029",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 42.08,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "40"
  ]
 },
 {
  "uf": "MT",
  "ncm": "85044029",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 42.08,
  "aliquota": 17.0,
  "fcp": 0.0,
  "validadoDesde": "2025-02-11",
  "notas": 3,
  "regrasNomus": [
   "139"
  ]
 },
 {
  "uf": "MT",
  "ncm": "94051190",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   55
  ],
  "nivel": "validado",
  "mva": 40.33,
  "aliquota": 17.0,
  "fcp": 0.0,
  "validadoDesde": "2025-01-16",
  "notas": 15,
  "regrasNomus": [
   "38"
  ]
 },
 {
  "uf": "MT",
  "ncm": "94051190",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   55
  ],
  "nivel": "validado",
  "mva": 40.33,
  "aliquota": 17.0,
  "fcp": 0.0,
  "validadoDesde": "2025-11-28",
  "notas": 38,
  "regrasNomus": [
   "131"
  ]
 },
 {
  "uf": "MT",
  "ncm": "94054900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   55
  ],
  "nivel": "parametrizado",
  "mva": 40.33,
  "aliquota": 17.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "38"
  ]
 },
 {
  "uf": "MT",
  "ncm": "94054900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   55
  ],
  "nivel": "validado",
  "mva": 40.33,
  "aliquota": 17.0,
  "fcp": 0.0,
  "validadoDesde": "2025-12-01",
  "notas": 2,
  "regrasNomus": [
   "131"
  ]
 },
 {
  "uf": "PA",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 36.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "validadoDesde": "2026-09-17",
  "notas": 1,
  "regrasNomus": [
   "82"
  ]
 },
 {
  "uf": "PA",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 36.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "validadoDesde": "2026-02-27",
  "notas": 1,
  "regrasNomus": [
   "153"
  ]
 },
 {
  "uf": "PA",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "60"
  ]
 },
 {
  "uf": "PA",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 46.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "106"
  ]
 },
 {
  "uf": "PA",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 46.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "163"
  ]
 },
 {
  "uf": "PA",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "73"
  ]
 },
 {
  "uf": "PA",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "197"
  ]
 },
 {
  "uf": "PA",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "175",
   "211"
  ]
 },
 {
  "uf": "PA",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "176"
  ]
 },
 {
  "uf": "PA",
  "ncm": "76169900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "93"
  ]
 },
 {
  "uf": "PA",
  "ncm": "76169900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "deducao": 7.0,
  "alerta": "O Nomus deduz 7% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 4%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "93"
  ]
 },
 {
  "uf": "PB",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "120"
  ]
 },
 {
  "uf": "PB",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 41.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "144"
  ]
 },
 {
  "uf": "PB",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "198"
  ]
 },
 {
  "uf": "PB",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "199"
  ]
 },
 {
  "uf": "PB",
  "ncm": "76169900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "99"
  ]
 },
 {
  "uf": "PB",
  "ncm": "76169900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 37.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "deducao": 7.0,
  "alerta": "O Nomus deduz 7% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 4%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "99"
  ]
 },
 {
  "uf": "PB",
  "ncm": "85044029",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "124"
  ]
 },
 {
  "uf": "PB",
  "ncm": "85044029",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "137"
  ]
 },
 {
  "uf": "PE",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "84"
  ]
 },
 {
  "uf": "PE",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "155"
  ]
 },
 {
  "uf": "PE",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 44.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "67"
  ]
 },
 {
  "uf": "PE",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 44.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "148"
  ]
 },
 {
  "uf": "PE",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   44,
   45
  ],
  "nivel": "parametrizado",
  "mva": 51.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "18"
  ]
 },
 {
  "uf": "PE",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   44,
   45
  ],
  "nivel": "parametrizado",
  "mva": 51.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "170"
  ]
 },
 {
  "uf": "PE",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "201"
  ]
 },
 {
  "uf": "PE",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "202"
  ]
 },
 {
  "uf": "PE",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "180"
  ]
 },
 {
  "uf": "PE",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54,
   74
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 20.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "181"
  ]
 },
 {
  "uf": "PR",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 50.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "validadoDesde": "2025-10-17",
  "notas": 1,
  "regrasNomus": [
   "88"
  ]
 },
 {
  "uf": "PR",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 50.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "160"
  ]
 },
 {
  "uf": "PR",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 50.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "2"
  ]
 },
 {
  "uf": "PR",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 50.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "171"
  ]
 },
 {
  "uf": "PR",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "78"
  ]
 },
 {
  "uf": "PR",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "208"
  ]
 },
 {
  "uf": "PR",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "192"
  ]
 },
 {
  "uf": "PR",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "193"
  ]
 },
 {
  "uf": "PR",
  "ncm": "76169900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "100"
  ]
 },
 {
  "uf": "PR",
  "ncm": "76169900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 19.0,
  "fcp": 0.0,
  "deducao": 12.0,
  "alerta": "O Nomus deduz 12% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 4%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "100"
  ]
 },
 {
  "uf": "PR",
  "ncm": "85044029",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "141"
  ]
 },
 {
  "uf": "PR",
  "ncm": "85044029",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 48.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "140"
  ]
 },
 {
  "uf": "PR",
  "ncm": "94051190",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 39.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "validadoDesde": "2025-06-02",
  "notas": 145,
  "regrasNomus": [
   "68"
  ]
 },
 {
  "uf": "PR",
  "ncm": "94054900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 39.0,
  "aliquota": 19.5,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "68"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 99.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 99%. O orçamento segue o Nomus até o financeiro corrigir. A dedução do Nomus (99%) é maior que a alíquota do ST (24%): o ICMS-ST sai zerado e só o FCP-ST é cobrado.",
  "notas": 0,
  "regrasNomus": [
   "213"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 99.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 99%. O orçamento segue o Nomus até o financeiro corrigir. A dedução do Nomus (99%) é maior que a alíquota do ST (24%): o ICMS-ST sai zerado e só o FCP-ST é cobrado.",
  "notas": 0,
  "regrasNomus": [
   "213"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 44.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 20% + FCP-ST de 2% (22% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "69"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 44.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 20% + FCP-ST de 2% (22% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "69"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 51.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 20% + FCP-ST de 2% (22% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "111"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 51.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 20% + FCP-ST de 2% (22% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "111"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 71.78,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "validadoDesde": "2025-01-10",
  "notas": 23,
  "regrasNomus": [
   "79"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "79"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "194"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "194"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "76169900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "deducao": 12.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 17% + FCP-ST de 0% (17% no total) com dedução de 12%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "101"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "76169900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 45.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "deducao": 12.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 17% + FCP-ST de 0% (17% no total) com dedução de 12%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "101"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "85044029",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 50.0,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "validadoDesde": "2025-06-26",
  "notas": 3,
  "regrasNomus": [
   "59"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "85044029",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "clientes": [
   "CASARAO LUSTRES - RECREIO",
   "CASARAO LUSTRES LTDA - BARRA",
   "CASARAO LUSTRES LTDA - BENFICA",
   "CASARAO LUSTRES LTDA UPTOWN",
   "CL LUTRES LTDA"
  ],
  "nivel": "parametrizado",
  "mva": 20.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 20% + FCP-ST de 2% (22% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "127"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "85044029",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 50.0,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "validadoDesde": "2025-02-21",
  "notas": 19,
  "regrasNomus": [
   "59"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "85044029",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "clientes": [
   "CASARAO LUSTRES - RECREIO",
   "CASARAO LUSTRES LTDA - BARRA",
   "CASARAO LUSTRES LTDA - BENFICA",
   "CASARAO LUSTRES LTDA UPTOWN",
   "CL LUTRES LTDA"
  ],
  "nivel": "parametrizado",
  "mva": 20.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 20.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 20% + FCP-ST de 2% (22% no total) com dedução de 20%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "127"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "94051190",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 52.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 22.0,
  "validadoDesde": "2025-01-09",
  "notas": 53,
  "regrasNomus": [
   "109"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "94051190",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "clientes": [
   "CASARAO LUSTRES - RECREIO",
   "CASARAO LUSTRES LTDA - BARRA",
   "CASARAO LUSTRES LTDA - BENFICA",
   "CASARAO LUSTRES LTDA UPTOWN",
   "CL LUTRES LTDA"
  ],
  "nivel": "validado",
  "mva": 20.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 22.0,
  "validadoDesde": "2025-01-30",
  "notas": 2,
  "regrasNomus": [
   "126"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "94051190",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 52.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 22.0,
  "validadoDesde": "2025-01-10",
  "notas": 65,
  "regrasNomus": [
   "109"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "94051190",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "clientes": [
   "CASARAO LUSTRES - RECREIO",
   "CASARAO LUSTRES LTDA - BARRA",
   "CASARAO LUSTRES LTDA - BENFICA",
   "CASARAO LUSTRES LTDA UPTOWN",
   "CL LUTRES LTDA"
  ],
  "nivel": "parametrizado",
  "mva": 20.0,
  "aliquota": 20.0,
  "fcp": 2.0,
  "deducao": 22.0,
  "notas": 0,
  "regrasNomus": [
   "126"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "94054900",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 52.0,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 22.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 22%. O orçamento segue o Nomus até o financeiro corrigir.",
  "validadoDesde": "2025-10-28",
  "notas": 1,
  "regrasNomus": [
   "58"
  ]
 },
 {
  "uf": "RJ",
  "ncm": "94054900",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 52.0,
  "aliquota": 22.0,
  "fcp": 2.0,
  "deducao": 22.0,
  "alerta": "No RJ a regra para operação interna é 22% (ICMS 20% + FECP 2%) sobre a diferença entre a base do ST e a da operação própria (a contabilidade confirmou em 02/10: \"22% é a alíquota efetiva\"). O Nomus parametriza ICMS-ST de 22% + FCP-ST de 2% (24% no total) com dedução de 22%. O orçamento segue o Nomus até o financeiro corrigir.",
  "validadoDesde": "2026-05-21",
  "notas": 5,
  "regrasNomus": [
   "58"
  ]
 },
 {
  "uf": "RN",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 2.0,
  "validadoDesde": "2025-12-15",
  "notas": 4,
  "regrasNomus": [
   "215"
  ]
 },
 {
  "uf": "RR",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "deducao": 12.0,
  "alerta": "O Nomus deduz 12% do ICMS da operação própria; a lei (alíquota interestadual do Senado) dá 7%. O orçamento segue o Nomus até o financeiro corrigir.",
  "notas": 0,
  "regrasNomus": [
   "72"
  ]
 },
 {
  "uf": "RR",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "209"
  ]
 },
 {
  "uf": "RS",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 69.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "90"
  ]
 },
 {
  "uf": "RS",
  "ncm": "39269090",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 69.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "161"
  ]
 },
 {
  "uf": "RS",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 66.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "70"
  ]
 },
 {
  "uf": "RS",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 66.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "151"
  ]
 },
 {
  "uf": "RS",
  "ncm": "73181300",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 69.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "55"
  ]
 },
 {
  "uf": "RS",
  "ncm": "73181300",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   43,
   44,
   83
  ],
  "nivel": "parametrizado",
  "mva": 69.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "172"
  ]
 },
 {
  "uf": "RS",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "80"
  ]
 },
 {
  "uf": "RS",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "210"
  ]
 },
 {
  "uf": "RS",
  "ncm": "76169000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 81.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "195"
  ]
 },
 {
  "uf": "RS",
  "ncm": "76169000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 81.0,
  "aliquota": 17.0,
  "fcp": 0.0,
  "alerta": "RS: a família de iluminação é excluída da ST pela norma (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "196"
  ]
 },
 {
  "uf": "SE",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "198"
  ]
 },
 {
  "uf": "SE",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "199"
  ]
 },
 {
  "uf": "SP",
  "ncm": "39269090",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "validado",
  "mva": 100.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "alerta": "SP: a responsabilidade do remetente RJ→SP não foi homologada e há vigências de 01/08 e 01/10/2026 (spec de 30/09). O Nomus cobra mesmo assim.",
  "validadoDesde": "2025-09-19",
  "notas": 1,
  "regrasNomus": [
   "91"
  ]
 },
 {
  "uf": "SP",
  "ncm": "73170020",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 68.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "alerta": "SP: a responsabilidade do remetente RJ→SP não foi homologada e há vigências de 01/08 e 01/10/2026 (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "125"
  ]
 },
 {
  "uf": "SP",
  "ncm": "73170020",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 68.0,
  "aliquota": 18.0,
  "fcp": 0.0,
  "alerta": "SP: a responsabilidade do remetente RJ→SP não foi homologada e há vigências de 01/08 e 01/10/2026 (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "152"
  ]
 },
 {
  "uf": "SP",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 18.0,
  "fcp": 0.0,
  "alerta": "SP: a responsabilidade do remetente RJ→SP não foi homologada e há vigências de 01/08 e 01/10/2026 (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "75"
  ]
 },
 {
  "uf": "SP",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 18.0,
  "fcp": 0.0,
  "alerta": "SP: a responsabilidade do remetente RJ→SP não foi homologada e há vigências de 01/08 e 01/10/2026 (spec de 30/09). O Nomus cobra mesmo assim.",
  "notas": 0,
  "regrasNomus": [
   "205"
  ]
 },
 {
  "uf": "TO",
  "ncm": "73209000",
  "origem": "0",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "198"
  ]
 },
 {
  "uf": "TO",
  "ncm": "73209000",
  "origem": "1",
  "movimentacoes": [
   35,
   38,
   40,
   54
  ],
  "nivel": "parametrizado",
  "mva": 71.78,
  "aliquota": 20.0,
  "fcp": 0.0,
  "notas": 0,
  "regrasNomus": [
   "199"
  ]
 }
];
